/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import LinkHandler from './Classes/LinkHandler';
import Header from './Classes/Header';
import BackToTop from './Classes/BackToTop';
import PrevNextPosition from './Classes/PrevNextPosition';
import MobileSliderHandler from './Classes/MobilesliderHandler';
import SwitchHandler from './Classes/SwitchHandler';
import TableChartPopup from './Classes/TableChartPopup';

import Accordion from './Classes/Accordion';
import VideScrollSection from './Classes/VideScrollSection';
import ScrollAnimate from './Classes/ScrollAnimate';
import Video from './Classes/Video';
import Sticky from 'sticky-js';
import SharesCSVHandler from './Classes/SharesCSVHandler';

var lazyLoadInstance = null;
var headerInstance = null;
var videScrollSectionInstance = null;
var scrollAnimateInstance = null;
var accordionInstance = null;
var backToTopInstance = null;
var prevNextPositionInstance = null;
var videoInstance = null;
var mobileSliderInstance = null;
var switchHandlerInstance = null;
var linkHandlerInstance = null;
var tableChartPopupInstance = null;

var stickyInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },
};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  new SharesCSVHandler();

  switchHandlerInstance = new SwitchHandler();

  mobileSliderInstance = new MobileSliderHandler({
    outerWrapperSelector: '.ns-mobile-slider',
    sliderBreakpoint: 992,
  });

  stickyInstance = new Sticky('.ns-video-section', {
    stickyContainer: '.ns-video-section-wrap',
    marginTop: document.querySelector('.header').offsetHeight,
    stickyClass: 'is-sticy'
  });

  videScrollSectionInstance = new VideScrollSection();
  scrollAnimateInstance = new ScrollAnimate();

  linkHandlerInstance = new LinkHandler();

  headerInstance = new Header({
    submenuSelector: '.main-menu__wrap--level-1',
    submenuTogglerSelector: '.main-menu__item--has-children .main-menu__link--level-0',
    menuTogglerSelector: '.js-menu-toggle',
    menuContainerSelector: '.header__menu',
    searchTogglerSelector: '.js-search-toggle',
    searchContainerSelector: '.header__searchform'
  });

  backToTopInstance = new BackToTop();

  accordionInstance = new Accordion({
    accordions: '.js-toggle-accordion'
  });

  prevNextPositionInstance = new PrevNextPosition({
    footer: '.footer',
    prevnext: '.prev-next',
    header: '.header',
    breakPointMd: 990,
  });

  videoInstance = new Video();

  tableChartPopupInstance = new TableChartPopup();

});
